import { styled } from '../../Styles/stitches.config'
import { StyledHeading } from '../../Atoms'

export const FrontBack = styled('div', {
    alignContent: 'center',
    WebkitBackfaceVisibility: 'hidden',
    bgc: 'white',
    border: '1px solid $neutral200',
    br: '$1',
    display: 'grid',
    gap: '$3',
    p: '$3',
    position: 'absolute',
    size: '100%',
    textAlign: 'center',
    transition: '$default',

    '&:hover': {
        boxShadow: '$default',
    },
})

export const StyledFront = styled(FrontBack, {
    [`& ${StyledHeading}`]: {
        borderBottom: '1px solid black',
        pb: '$2',
    },

    variants: {
        variant: {
            ImageHeader: {
                [`& ${StyledHeading}`]: {
                    borderBottom: 'none',
                    p: '$0',
                },
            },
            HeaderImage: {},
        },
    },
})

export const StyledBack = styled(FrontBack, {
    transform: 'rotateX(-180deg)',

    variants: {
        variant: {
            ImageHeader: {},
            HeaderImage: {},
        },
    },
})

export const StyledCardFlip = styled('div', {
    bgc: 'transparent',
    cursor: 'pointer',
    display: 'grid',
    position: 'relative',
    WebkitTransformStyle: 'preserve-3d',
    transition: '$slow',
    w: '100%',

    variants: {
        flipped: {
            true: {
                transform: 'rotateX(180deg)',
            },
            false: {},
        },
    },
})
